<script>
import { Pie, mixins } from "vue-chartjs";

export default {
  extends: Pie,
  mixins: [mixins.reactiveProp],

  props: {
    dark: {
      type: Boolean,
      require: false,
    },
    options: {
      type: Object,
      required: true,
    },
    color1: {
      type: Array,
      required: true,
    },
    width: {
      required: true,
    },
    height: {
      required: true,
    },
  },

  data() {
    return {
      radialGradient1a: null,
      radialGradient1b: null,
      radialGradient1c: null,
      radialGradient1d: null,

      borderColor1: [],
      backgroundColor1: [],
      hoverBackgroundColor1: [],
    };
  },

  methods: {
    createradialGradient1a(x0, y0, r0, x1, y1, r1) {
      /*       this.radialGradient1a = this.$refs.canvas
        .getContext("2d")
        .createradialGradient(x0, y0, x1, y1);
 */
      this.radialGradient1a = this.$refs.canvas
        .getContext("2d")
        .createRadialGradient(x0, y0, r0, x1, y1, r1);

      this.radialGradient1a.addColorStop(0, this.color1[0].toString());
      this.radialGradient1a.addColorStop(0.5, this.color1[1].toString());
      this.radialGradient1a.addColorStop(1, this.color1[2].toString());

      this.borderColor1[0] = this.radialGradient1a;
      this.backgroundColor1[0] = this.radialGradient1a;
      this.hoverBackgroundColor1[0] = this.radialGradient1a;
    },

    createradialGradient1b(x0, y0, r0, x1, y1, r1) {
      this.radialGradient1b = this.$refs.canvas
        .getContext("2d")
        .createRadialGradient(x0, y0, r0, x1, y1, r1);

      this.radialGradient1b.addColorStop(0, this.color1[3].toString());
      this.radialGradient1b.addColorStop(0.5, this.color1[4].toString());
      this.radialGradient1b.addColorStop(1, this.color1[5].toString());

      this.borderColor1[1] = this.radialGradient1b;
      this.backgroundColor1[1] = this.radialGradient1b;
      this.hoverBackgroundColor1[1] = this.radialGradient1b;
    },

    createradialGradient1c(x0, y0, r0, x1, y1, r1) {
      this.radialGradient1c = this.$refs.canvas
        .getContext("2d")
        .createRadialGradient(x0, y0, r0, x1, y1, r1);

      this.radialGradient1c.addColorStop(0, this.color1[6].toString());
      this.radialGradient1c.addColorStop(0.5, this.color1[7].toString());
      this.radialGradient1c.addColorStop(1, this.color1[8].toString());

      this.borderColor1[2] = this.radialGradient1c;
      this.backgroundColor1[2] = this.radialGradient1c;
      this.hoverBackgroundColor1[2] = this.radialGradient1c;
    },

    createradialGradient1d(x0, y0, r0, x1, y1, r1) {
      this.radialGradient1d = this.$refs.canvas
        .getContext("2d")
        .createRadialGradient(x0, y0, r0, x1, y1, r1);

      this.radialGradient1d.addColorStop(0, this.color1[9].toString());
      this.radialGradient1d.addColorStop(0.5, this.color1[10].toString());
      this.radialGradient1d.addColorStop(1, this.color1[11].toString());

      this.borderColor1[3] = this.radialGradient1d;
      this.backgroundColor1[3] = this.radialGradient1d;
      this.hoverBackgroundColor1[3] = this.radialGradient1d;
    },

    updateChart() {
      // chartData is created in the mixin

      let h = this.height;
      let w = this.width;

      let r1 = h * 1.65;

      switch (this.color1.length / 3) {
        case 1:
          this.createradialGradient1a(w / 2, h / 2, 0, w / 2, h / 2, r1);
          break;
        case 2:
          this.createradialGradient1a(w / 2, h / 2, 0, w / 2, h / 2, r1);
          this.createradialGradient1b(w / 2, h / 2, 0, w / 2, h / 2, r1);
          break;
        case 3:
          this.createradialGradient1a(w / 2, h / 2, 0, w / 2, h / 2, r1);
          this.createradialGradient1b(w / 2, h / 2, 0, w / 2, h / 2, r1);
          this.createradialGradient1c(w / 2, h / 2, 0, w / 2, h / 2, r1);
          break;

        case 4:
          this.createradialGradient1a(w / 2, h / 2, 0, w / 2, h / 2, r1);
          this.createradialGradient1b(w / 2, h / 2, 0, w / 2, h / 2, r1);
          this.createradialGradient1c(w / 2, h / 2, 0, w / 2, h / 2, r1);
          this.createradialGradient1d(w / 2, h / 2, 0, w / 2, h / 2, r1);
          break;
        /*  */
        default:
          break;
      }

      this.renderChart(
        {
          /*    labels: this.labels, */
          datasets: [
            {
              data: this.chartData,
              borderColor: this.borderColor1,
              /*               borderColor: ["#333333", "333333", "333333", "333333"], */
              backgroundColor: this.backgroundColor1,
              hoverBackgroundColor: this.hoverBackgroundColor1,
              hoverBorderColor: this.borderColor1,
            },
          ],
        },
        this.options
      );
    },
  },
  mounted() {
    // this.chartData is created in the mixin.
    this.updateChart();
  },
  watch: {
    dark: function() {
      this._data._chart.destroy();

      this.updateChart();
    },
  },
};
</script>
